import { gql, useMutation } from '@apollo/client'

import type { CartInfoInput, SyncCartResult } from '../types'

const SYNC_CART_MUTATION = gql`
  mutation SyncCart($cart: CartInfoInput!) {
    syncCart(cart: $cart) {
      id
      product_id
      amount
      shop_id
      delivery_cost
      usedPromocode
    }
  }
`

export interface SyncCartVariables {
  cart: CartInfoInput
}

export interface SyncCartResponse {
  syncCart: SyncCartResult[]
}

export function useMutateSyncCart () {
  return useMutation<SyncCartResponse, SyncCartVariables>(SYNC_CART_MUTATION)
}
